import React from 'react';
import { GelTabs, GelTab } from '@tal-gel/components';
import { get, isEmpty } from 'lodash';
import PolicyExclusion from './PolicyExclusion';

export default function PolicyExclusionTab(props) {
    let policyLives;

    if (!props.policyLives || isEmpty(props.policyLives)) {
        policyLives = [0];
    } else {
        policyLives = props.policyLives;
    }

    return (
        <GelTabs condensed>
            {policyLives.map((policyLife, policyIndex) =>
                <GelTab key={policyIndex} title={get(policyLife, 'fullName', '')}>
                    <PolicyExclusion policyExclusion={props.policyExclusion} policyLife={policyLife} coverDetails = {props.coverDetails} policyDetails={props.policyDetails}
                        toggleDisplayExclusionWordingShort={(p) => props.toggleDisplayExclusionWordingShort(p)}></PolicyExclusion>
                </GelTab>
            )}
        </GelTabs>
    );
}